import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { BTActivationUpdateRequest } from "../shared/BTActivationUpdateRequest";
import { DataService_BusTrackerActivation } from "../shared/data.service";
import { PreviewQRRequest } from "../shared/PreviewQRRequest";
import * as moment from "moment";

@Component({
	selector: "app-edit-btactivation",
	templateUrl: "./edit-btactivation.component.html",
	styleUrls: ["./edit-btactivation.component.css"],
})
export class EditBTActivationComponent implements OnInit {
	constructor(
		private sanitizer: DomSanitizer,
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private BTActivationService: DataService_BusTrackerActivation
	) {}

	ngOnInit(): void {
		// console.log("Edit Data");
		// console.log(this.dialogConfig.data);

		this.ActivationID = this.dialogConfig.data.ActivationID;
		this.ActivationCode = this.dialogConfig.data.ActivationCode;
		this.ActivationCodeShort = this.dialogConfig.data.ActivationCodeShort;

		this.AvailableCount = this.dialogConfig.data.AvailableCount;
		this.TotalCount = this.dialogConfig.data.TotalCount;

		this.NewAvailableCount = this.dialogConfig.data.AvailableCount;
		this.NewTotalCount = this.dialogConfig.data.TotalCount;

		this.MinChange = this.AvailableCount * -1;

		// this.IssueDate = new Date(this.dialogConfig.data.IssueDate);
		this.IssueDateDesc = this.dialogConfig.data.IssueDateDesc;
		this.ExpireDate = new Date(this.dialogConfig.data.ExpireDate);

		this.Expires = Number(moment(this.ExpireDate).format("YYYYY")) == 9999 ? 0 : 1;
	}

	//////////////////////////////////////////////////////////////
	// Data
	//////////////////////////////////////////////////////////////

	ActivationCodeShort: any = "";

	ActivationID: any = 0;
	ActivationCode: any = "";
	AvailableCount: any = 0;
	TotalCount: any = 0;
	NewAvailableCount: any = 0;
	NewTotalCount: any = 0;

	MinChange: any = 0;

	ChangeAmount: any = 0;

	AddSubText: any = "Add Activations";

	IssueDateDesc: any = "";
	// IssueDate: Date = new Date();

	Expires: any = false;
	ExpireDate: Date = new Date();

	errorMessage: any = "";

	Processing: any = false;

	DebugPhotoData: any = "";
	ToEncrypt: any = "";
	EncryptedText: any = "";
	DebugURL: any = "";

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Buttons
	//////////////////////////////////////////////////////////////
	onUpdate() {
		this.errorMessage = "";

		//
		// Error handling
		//

		// var fiDate = moment(this.IssueDate).format("MM/DD/YYYY");
		var feDate = this.Expires == true ? moment(this.ExpireDate).format("MM/DD/YYYY") : "";

		if (String(feDate).toLowerCase().indexOf("invalid") != -1) {
			this.errorMessage = "Invalid issue date or expire date";

			return;
		}

		if (this.NewAvailableCount < 0) {
			this.errorMessage = "Available count must be >= 0";
			return;
		}

		if (this.NewTotalCount <= 0) {
			this.errorMessage = "Total count must be > 0";
		}

		//
		// Create Request
		//
		this.Processing = true;

		let parms: BTActivationUpdateRequest = {
			ActivationID: this.ActivationID,
			ActivationCodeShort: this.ActivationCodeShort,
			AvailableCount: this.NewAvailableCount,
			TotalCount: this.NewTotalCount,
			ExpireDate: feDate,
		};

		//
		// Call SP
		//

		var result = this.BTActivationService.BTActivationUpdate(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Activation code was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "edit",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Activation Code",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	onPreview() {
		this.Processing = true;

		let parms: PreviewQRRequest = {
			ActivationCode: this.ActivationCode,
			URL: this.DebugURL,
		};

		var result = this.BTActivationService.BTActivationPreviewDebugQRCode(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				this.ToEncrypt = response[0];
				this.EncryptedText = response[1];
				this.DebugPhotoData = this.sanitizer.bypassSecurityTrustResourceUrl(response[2]);
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	//////////////////////////////////////////////////////////////

	//////////////////////////////////////////////////////////////
	// Events
	//////////////////////////////////////////////////////////////

	onChangeAmountChange(val) {
		this.ChangeAmount = val;

		if (this.ChangeAmount >= 0) {
			this.AddSubText = "Add Activations";
		} else {
			this.AddSubText = "Subtract Activations";
		}

		this.NewAvailableCount = this.AvailableCount + val;
		this.NewTotalCount = this.TotalCount + val;
	}

	onExpiresChange(val) {
		this.Expires = val;

		if (this.Expires == true) {
			this.ExpireDate = new Date();
		}
	}

	IssueGrowCell(val) {
		var element = <HTMLElement>val.element;
		element = element.parentElement.parentElement;
		element.style.height = "290px";
		element.style.width = "255px";
	}

	//Reset size when the date picker popup is closed
	IssueShrinkCell(val) {
		var element = <HTMLElement>val.element;
		element = element.parentElement.parentElement;
		element.style.height = "26.49px";
		element.style.width = "125.56px";
	}

	ExpireGrowCell(val) {
		var element = <HTMLElement>val.element;
		element = element.parentElement.parentElement;
		element.style.height = "290px";
		element.style.width = "255px";

		var popup = <HTMLElement>document.getElementsByClassName("ng-trigger-overlayAnimation")[0];
		popup.style.top = "27px";
	}

	//Reset size when the date picker popup is closed
	ExpireShrinkCell(val) {
		var element = <HTMLElement>val.element;
		element = element.parentElement.parentElement;
		element.style.height = "26.49px";
		element.style.width = "125.56px";
	}

	//////////////////////////////////////////////////////////////
}
